// Redux Actions

// Sport List For Date
export const GET_SPORTS_LIST_REQUEST = 'api/GET_SPORTS_LIST_REQUEST';
export const GET_SPORTS_LIST_SUCCESS = 'api/GET_SPORTS_LIST_SUCCESS';
export const GET_SPORTS_LIST_ERROR = 'api/GET_SPORTS_LIST_ERROR';
export const SET_COMPETITION_LOADED = 'api/SET_COMPETITION_LOADED';
export const CLEAR_SPORT_STORE = 'sport/CLEAR_SPORT_STORE';
export const SHOW_COMPETITIONS = 'sport/SHOW_COMPETITIONS';

// Competitions List For Sport
export const GET_COMPETITIONS_LIST_REQUEST = 'api/GET_COMPETITIONS_LIST_REQUEST';
export const GET_COMPETITIONS_LIST_SUCCESS = 'api/GET_COMPETITIONS_LIST_SUCCESS';
export const GET_HIGHLIGHTED_COMPETITIONS_LIST_SUCCESS = 'api/GET_HIGHLIGHTED_COMPETITIONS_LIST_SUCCESS';
export const GET_COMPETITIONS_LIST_ERROR = 'api/GET_COMPETITIONS_LIST_ERROR';

// Set available sports
export const SET_AVAILABLE_SPORT = 'available/SET_AVAILABLE_SPORT';

// Sports Filter
export const FILTER_ALL_SPORTS = 'filter/FILTER_ALL_SPORTS';
export const SET_ALL_SPORTS = 'filter/SET_ALL_SPORTS';

export const FILTER_DATETIME = 'filter/FILTER_DATETIME';
export const FILTER_DATETIME_SUCCESS = 'filter/FILTER_DATETIME_SUCCESS';

export const FILTER_LIVE = 'filter/FILTER_LIVE';
export const SET_FILTER_LIVE = 'filter/SET_FILTER_LIVE';

export const FILTER_SPORT = 'filter/FILTER_SPORT';
export const SORT_SPORTS_LIST = 'sort/SORT_SPORTS_LIST';
export const CLEAR_SORTED_SPORTS = 'sort/CLEAR_SORTED_SPORTS';

// Favourites
export const FAVOURITES_CHANGE = 'favourites/FAVOURITES_CHANGE';
export const FAVOURITES_MATCH = 'favourites/FAVOURITES_MATCH';
export const FAVOURITES_COUNTER = 'favourites/FAVOURITES_COUNTER';
export const SET_FAVOURITES_COMPETITIONS_LIST = 'favourites/SET_FAVOURITES_COMPETITIONS_LIST';
export const UPDATE_FAVOURITES = 'favourites/UPDATE_FAVOURITES';
export const REMOVE_FAVOURITES_MATCH = 'favourites/REMOVE_FAVOURITES_MATCH';

export const GET_YESTERDAY_TOMORROW_REQUEST = 'favourites/GET_YESTERDAY_TOMORROW_REQUEST';
export const GET_YESTERDAY_TOMORROW__SUCCESS = 'favourites/GET_YESTERDAY_TOMORROW__SUCCESS';
export const GET_YESTERDAY_TOMORROW_ERROR = 'favourites/GET_YESTERDAY_TOMORROW_ERROR';

export const GET_TODAY_REQUEST = 'favourites/GET_TODAY_REQUEST';
export const GET_TODAY__SUCCESS = 'favourites/GET_YESTERDAY_TOMORROW__SUCCESS';
export const GET_TODAY_ERROR = 'favourites/GET_TODAY_ERROR';

export const SET_YESTERDAY_SPORT = 'favourites/SET_YESTERDAY_SPORT';
export const SET_TOMORROW_SPORT = 'favourites/SET_TOMORROW_SPORT';
export const SET_TODAY_SPORT = 'favourites/SET_TODAY_SPORT';

export const GET_FAVOURITES_REQUEST = 'favourites/GET_FAVOURITES_REQUEST';
export const GET_FAVOURITES_SUCCESS = 'favourites/GET_FAVOURITES_SUCCESS';
export const GET_FAVOURITES_ERROR = 'favourites/GET_FAVOURITES_ERROR';

// Set available sports
export const SET_PROMO_HIGHLIGHTED = 'favourites/PROMO_HIGHLIGHTED';

// Dictionary
export const INIT_DICTIONARY = 'dictionary/INIT_DICTIONARY';

// Tooltip
export const SHOW_TOOLTIP = 'tooltip/SHOW_TOOLTIP';
export const HIDE_TOOLTIP = 'tooltip/HIDE_TOOLTIP';

// Filter Bar
export const LIVE = 'LIVE';

//Local Storage
export const CLEAR_LOCAL_STORAGE = 'localStorage/CLEAR_LOCAL_STORAGE';
export const SET_LOCAL_STORAGE_DATE = 'locaStorage/SET_LOCAL_STORAGE_DATE';
export const REMOVE_FAVOURITES_MATCH_FROM_LOCALSTORAGE = 'localStorage/REMOVE_FAVOURITES_MATCH_FROM_LOCALSTORAGE';
export const UPDATE_LOCAL_STORAGE = 'localStorage/UPDATE_LOCAL_STORAGE';
export const INCREMENT_SESSION_COUNTER = 'localStorage/INCREMENT_SESSION_COUNTER';
export const SET_IS_DIFFERENT_TZS = 'locaStorage/SET_IS_DIFFERENT_TZS';

//Local storage keys
export const PREFERRED_COUNTER = 'preferredCount';
export const PREFERRED_MATCH = 'preferredMatch';
export const PREFERRED_MAP = 'preferredMap';
export const SESSION_COUNTER = 'sessionCount';
export const NEW_FEATURES = 'newFeatures';

// Table Types
export const TYPE_HUB = 'HUB';
export const TYPE_PREFERRED = 'PREFERRED';

// Timing Tag
export const PREMATCH = 'PreMatch';
export const FULLTIME = 'FullTime';
export const FULLTIME90 = 'FullTime90';
export const FULLTIMEPENS = 'FullTimePens';
export const SHOOTOUT = 'ShootOut';
export const ABANDONED = 'Abandoned';
export const POSTPONED = 'Postponed';
export const DELAYED = 'Delayed';
export const NOTPLAYED= 'Notplayed';
export const WALKOVER_TAG= 'Walkover';
export const CANCELED = 'Cancelled';
export const SUSPENDED = 'Suspended';
export const HALFTIME = 'HalfTime';
export const EXTRAHALFTIME = 'ExtraHalfTime';
export const FIRSTHALF = 'FirstHalf';
export const SECONDHALF = 'SecondHalf';
export const EXTRAFIRSTHALF = 'ExtraFirstHalf';
export const EXTRASECONDHALF = 'ExtraSecondHalf';

// Match Status
export const PREMATCH_STATUS = 'PREMATCH';
export const POSTPONED_STATUS = 'POSTPONED';
export const WALKOVER_STATUS= 'WALKOVER';
export const NOTPLAYED_STATUS= 'NOTPLAYED';
export const CANCELLED_STATUS = 'CANCELLED';
export const LIVE_STATUS = 'LIVE';
export const FULL_STATUS = 'FULL';

// Race Status
export const NOTSTARTED = 'NOTSTARTED';
export const ON_TRACK = 'ON TRACK';
export const FINISHED = 'FINISHED';
export const RED_FLAG = 'RED FLAG';
export const YELLOW_FLAG = 'YELLOW FLAG';
export const SAFETY_CAR = 'SAFETY CAR';
export const ABORTED = 'ABORTED';
export const TOAPPROVAL = 'TOAPPROVAL';
export const TBD = 'TBD';

// Race Session
export const RACE = 'RACE';

//Tennis Status
export const INPLAY = 'INPLAY';
export const BYE = 'BYE';
export const WALKOVER = 'WALKOVER';
export const RETIRED = 'RETIRED';
export const DEFAULTED = 'DEFAULTED';
export const WIN = 'WIN';
export const SUSPENDED_STATUS = 'SUSPENDED';

// Tennis competition type
export const MENS_SINGLES = 'Mens Singles';
export const WOMENS_SINGLES = 'Womens Singles';
export const COMPETITION_TYPE_MAN = 'Mens';
export const COMPETITION_TYPE_WOMAN = 'woman';

// Basket Status
export const CANCELLED = 'CANCELLED';
export const FIXTURE = 'FIXTURE';
export const PLAYING = 'PLAYING';
export const PLAYED = 'PLAYED';

// Basket periodId
export const PRE_GAME = '0';
export const FIRST_HALF_TIME = '1';
export const SECOND_HALF_TIME = '2';
export const FIRST_QUARTER = '3';
export const SECOND_QUARTER = '4';
export const THIRD_QUARTER = '5';
export const FOURTH_QUARTER = '6';
export const OVERTIME = '7';
export const FIRST_HALF_BREAK = '11';
export const HALF_TIME_BREAK = '12';
export const SECOND_HALF_BREAK = '13';
export const BEFORE_OVERTIME = '14';
export const POST_GAME = '15';

// Cycling Status
export const INPROGRESS = 'INPROGRESS';
